import styled from 'styled-components';
import Background from 'assets/img/NewImages/Auriscom12.jpg';

export const StyledContainer = styled('div')`
  overflow-y: hidden;
  background-image: ${() => `url(${Background})`};
  min-height: 100vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  margin-left: auto;
  margin-right: auto;
`;

export const LoginLogo = styled.img.attrs({
  src: require('../../../assets/img/Auriscom logo.png'),
  alt: 'Auriscom Logo'
})`
  position: absolute;
  top: 20px;
  left: 20px;
  width: 200px;
  height: auto;
  object-fit: contain;
`;

export const FormContainer = styled('div')`
  margin-left: 200px;
  margin-top: 20px;
  width: 450px;
  display: flex;
  flex-direction: column;
`;

export const HeroTextContainer = styled('div')`
  margin-left: 200px;
  margin-top: 100px;
  margin-bottom: 40px;
  max-width: 450px;
  text-align: left;
`;

export const MainHeading = styled('h1')`
  color: white;
  font-size: 36px;
  font-weight: bold;
  margin: 0 0 12px 0;
  line-height: 1.2;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  white-space: nowrap;
`;

export const SubHeading = styled('p')`
  color: #60a5fa;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  line-height: 1.4;
`;
